export default () => ({
  '@global': {
    'html, body, #root': {
      width: '100%',
      height: '100%',
      padding: 0,
      margin: 0,
      display: 'flex',
      flex: 1,
      backgroundColor: '#ffffff',
      fontFamily: "'Josefin Sans', sans-serif"
    },
    a: {
      textDecoration: 'none'
    },
    '#dialog-portal': {
      zIndex: 1000
    },
    '#select-menu-portal': {
      zIndex: 1500
    }
  }
})
